<template>
  <div class="hx-login-container">
    <div class="hx-login-bg-top">
      <div class="hx-login-logo">
        <img src="static/images/login-logo.png" alt="" />
      </div>
    </div>
    <div class="hx-login-bg-footer"></div>
    <div class="hx-login-template">
      <el-form class="hx-login-template-form" label-width="100px" ref="loginForm" :model="listParams" :rules="checkListParams">
        <el-form-item prop="username" label="用户名：">
          <el-input placeholder="请输入用户名：" v-model="listParams.username"> </el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码：">
          <el-input @keyup.native.13="login('loginForm')" placeholder="请输入密码：" v-model="listParams.password" type="password"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="isDisabled" :loading="buttonLoading" style="width: 300px; margin-top: 10px; background-color: teal; border-color: teal" type="primary" @click="login('loginForm')">
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      listParams: {
        username: "",
        password: ""
      },
      isDisabled: false,
      buttonLoading: false,
      checkListParams: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  mounted() {
    localStorage.clear();
    const params = this.getRequest();
    this.listParams.username = params.username;
    this.listParams.password = params.password;
    if (this.listParams.username && this.listParams.password) {
      this.login("loginForm");
    }
  },
  methods: {
    login(name) {
      this.isDisabled = true;
      this.buttonLoading = true;
      const bodyParams = Object.assign({}, this.listParams);
      bodyParams.password = md5(bodyParams.password).toUpperCase();
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + "/admin/login",
            method: "POST",
            body: bodyParams
          })
            .then(res => {
              if (res.body.sysStatus === 0 && res.body.apiStatus === 0) {
                this.isDisabled = false;
                this.buttonLoading = false;
                if (res.body.data) {
                  localStorage.setItem("TOKEN", res.body.data.token);
                  localStorage.setItem("username", res.body.data.username);
                  this.$router.push({
                    name: "supplySystem"
                  });
                }
              } else {
                this.isDisabled = false;
                this.buttonLoading = false;

                this.$refs.loginForm.resetFields();
              }
            })
            .catch(err => {
              this.isDisabled = false;
              this.buttonLoading = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
          this.buttonLoading = false;
        }
      });
    },
    getRequest() {
      const url = location.search; // 获取url中"?"符后的字串
      const theRequest = {};
      if (url.indexOf("?") !== -1) {
        const str = url.substr(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    }
  }
};
</script>

<style lang="less" scoped>
.hx-login-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .hx-login-bg-top {
    overflow: hidden;
    width: 100%;
    height: 300px;
    background: linear-gradient(-100deg, #008080, #1b6f49);
    .hx-login-logo {
      width: 500px;
      height: 200px;
      margin: 30px auto;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
  .hx-login-bg-footer {
    width: 100%;
    height: 100px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .hx-login-template {
    width: 500px;
    height: 300px;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    margin: -50px auto;
    z-index: 9999;
    background: #ffffff;
    position: relative;
    .hx-login-template-form {
      width: 400px;
      height: 200px;
      position: absolute;
      top: 70px;
      left: 30px;
    }
  }
}
</style>
